import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { breakpoint } from 'src/styles/dontgiftguide.styles';
import { dggTheme } from '../../../../styles/dggTheme';

const { spacing } = dggTheme;

export const root = css`
  text-align: center;
  color: #fff;
`;

export const content = css`
  padding: ${pxToRem(spacing.md)};
`;

export const logo = css`
  height: ${pxToRem(210)};
  margin: ${pxToRem(spacing.sm)} 0;

  ${mediaQuery(
    { min: breakpoint },
    css`
      height: ${pxToRem(420)};
    `,
  )}
`;

export const subtitle = css`
  margin: 0;
  font-size: ${pxToRem(20)};
  line-height: 1.25;

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(40)};
    `,
  )}
`;

export const introductionCopy = css`
  margin-bottom: ${pxToRem(40)};
  font-size: ${pxToRem(16)};
  line-height: 1.25;

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(28)};
    `,
  )}
`;

export const collage = css`
  display: block;
  margin: 0 auto ${pxToRem(30)} auto;
  padding: 0 ${pxToRem(30)};
  max-width: 100%;
`;
